import React from 'react'
import PropTypes from "prop-types";
import {getFormInputCssClass, hasMessage, setupOnExtractData} from "../../../util/FormUtil";
import { PROP_NAME_COUNTRY } from "./CountryInputComponent";
import {PROP_NAME_PHONE_COUNTRY_CODE, PROP_NAME_PHONE_EXTENSION, PROP_NAME_PHONE_NUMBER} from "./PhoneInputComponent";
import {fetchResponseHandler} from "../../../util/FetchUtil";
import {trimToEmpty} from "../../../util/StringUtil";

export const PROP_NAME_JOB_ROLE = "jobRole";
export const PROP_NAME_COMPANY_TYPE = "companyType";
export const PROP_NAME_COMPANY_NAME = "companyName";

const KEYS = [PROP_NAME_JOB_ROLE, PROP_NAME_COMPANY_TYPE, PROP_NAME_COMPANY_NAME, PROP_NAME_COUNTRY];
let companyNamePatternFailMessage = "Company Name must not contain special characters";

class AboutYouInputComponent extends React.Component {
    constructor(props) {
        super(props);
        this.jobRoleChange = this.jobRoleChange.bind(this);
        this.companyTypeChange = this.companyTypeChange.bind(this);
        this.companyNameChange = this.companyNameChange.bind(this);
        this.countryChange = this.countryChange.bind(this);
        this.extractData = this.extractData.bind(this);
    }

    extractData(){
        const {data, hideCountry} = this.props;
        const result = {};
        for (let i = 0; i < KEYS.length; i++){
            const key = KEYS[i];
            if (key !== PROP_NAME_COUNTRY || ! hideCountry){
                result[key] = trimToEmpty(data[key]);
            }
        }
        return result;
    }

    componentDidMount() {
        const {setFormState, userDataService, metadata, data, hideCountry, allowSkipPhoneInput} = this.props;

        for (let i = 0; i < KEYS.length; i++){
            const key = KEYS[i];
            //Using allowSkipPhoneInput to identify EBS setup
            if(hideCountry && key === PROP_NAME_COUNTRY && allowSkipPhoneInput ){
                continue;
            }
            if (! metadata[key]){
                setFormState({
                    property: key,
                    data: data[key] ? data[key] : "",
                    metadata: {
                        dirty: false,
                        valid: data[key] || key === PROP_NAME_COMPANY_NAME || key === PROP_NAME_COMPANY_TYPE || (key === PROP_NAME_COUNTRY && hideCountry)
                }});
            }
        }
        //Using allowSkipPhoneInput to identify EBS setup, no need to pass skipIpStackServiceCall since is required allowSkipPhoneInput to be true
        if(!data[PROP_NAME_COUNTRY] && userDataService && !hideCountry && !allowSkipPhoneInput ) {
            userDataService.getIPStack()
                .then(fetchResponseHandler)
                .then(
                    function successCallback(data) {
                        var countryCode = String(data.country_code);
                        setFormState({property: PROP_NAME_COUNTRY, data: countryCode, metadata: {dirty: true, valid: true}});
                    },
                    function errorCallback(data) {
                        console.log("Failed to fetch data from IPStack.");
                    });
        }

        setupOnExtractData(this);
    }

    jobRoleChange(e){
        const {setFormState, data} = this.props;
        let isDirty = false;
        let isValid = false;

        if(e.target.value && e.target.value.trim().length > 0) {
            isDirty = true;
            isValid = true;
        }

        //If going from null or ITI, we would be displaying company type, so set the data there to null and the valid to
        //false since it needs to be populated
        if((!data[PROP_NAME_JOB_ROLE] || data[PROP_NAME_JOB_ROLE] === 'Independent Trader/Investor') &&
            e.target.value !== 'Independent Trader/Investor'){
            setFormState({property: PROP_NAME_COMPANY_TYPE, data: null, metadata:{dirty:false, valid:false}})
            setFormState({property: PROP_NAME_COMPANY_NAME, data: null, metadata:{dirty:false, valid:false}})
        }

        //If going to ITI, remove the data for company type and name and mark the fields as valid again
        if(e.target.value == 'Independent Trader/Investor'){
            setFormState({property: PROP_NAME_COMPANY_TYPE, data: null, metadata:{dirty:false, valid:true}})
            setFormState({property: PROP_NAME_COMPANY_NAME, data: null, metadata:{dirty:false, valid:true}})
        }

        setFormState({property: PROP_NAME_JOB_ROLE, data: e.target.value, metadata:{dirty: isDirty, valid: isValid}})
    }

    companyTypeChange(e){
        const {setFormState} = this.props;
        let isDirty = false;
        let isValid = false;

        if(e.target.value && e.target.value.trim().length > 0) {
            isDirty = true;
            isValid = true;
        }
        setFormState({property: PROP_NAME_COMPANY_TYPE, data: e.target.value, metadata:{dirty: isDirty, valid: isValid}})
    }

    companyNameChange(e){
        const {setFormState, userDataInit} = this.props;
        let isDirty = false;
        let isValid = false;
        let message = null;

        const value = e.target.value;
        const companyPattern = userDataInit[PROP_NAME_COMPANY_NAME].companyPattern;
        const companyMaxLength = userDataInit[PROP_NAME_COMPANY_NAME].maxLengthCompany;

        // Validation
        if(value && value.trim().length > 0) {
            isDirty = true;
            if (companyPattern.test(value)) {                       // checkPattern
                if (companyMaxLength >= (value.trim().length)) {    // checkLength
                    isValid = true;
                } else {
                    message = "Company Name length must not exceed the length of " + companyMaxLength + "  characters";
                }
            } else {
                message = companyNamePatternFailMessage;
            }
        }
        setFormState({property: PROP_NAME_COMPANY_NAME, data: e.target.value, metadata:{dirty: isDirty, valid: isValid, message: message}})
    }

    countryChange(e){
        const {setFormState} = this.props;
        let isDirty = false;
        let isValid = false;

        if(e.target.value && e.target.value.trim().length > 0) {
            isDirty = true;
            isValid = true;
        }
        setFormState({property: PROP_NAME_COUNTRY, data: e.target.value, metadata:{dirty: isDirty, valid: isValid}})
    }


    render() {
        const {data, userDataInit, metadata, hideCountry} = this.props;

        const hasInputClassJobRole = getFormInputCssClass(metadata, PROP_NAME_JOB_ROLE);
        const hasInputClassCountry = getFormInputCssClass(metadata, PROP_NAME_COUNTRY);
        const hasInputClassCompanyType = getFormInputCssClass(metadata, PROP_NAME_COMPANY_TYPE);
        const hasInputClassCompanyName = getFormInputCssClass(metadata, PROP_NAME_COMPANY_NAME);
        const displayCompanyInfo = data[PROP_NAME_JOB_ROLE] && data[PROP_NAME_JOB_ROLE] !== 'Independent Trader/Investor';

        return (
            <div className={"grid form-fields"}>
                <div className="grid__col-sm-6">
                    <label htmlFor={PROP_NAME_JOB_ROLE}>Job Role</label>
                    <select id={PROP_NAME_JOB_ROLE}
                            value={data[PROP_NAME_JOB_ROLE]}
                            className={"select-input--large " + hasInputClassJobRole}
                            onChange={this.jobRoleChange}
                    >
                        <option value={""}>Select...</option>
                        {
                            userDataInit[PROP_NAME_JOB_ROLE].jobRoles
                                .map(c =>
                                    (<option value={c} dangerouslySetInnerHTML={{__html: c}}></option>)
                                )
                        }
                    </select>
                </div>
                {
                    ! hideCountry &&
                    <div className="grid__col-sm-6">
                        <label htmlFor={PROP_NAME_COUNTRY}>Country</label>
                        <select id={PROP_NAME_COUNTRY}
                                className={"select-input--large " + hasInputClassCountry}
                                value={data[PROP_NAME_COUNTRY]}
                                onChange={this.countryChange}
                        >
                            <option value={""}>Select...</option>
                            {
                                userDataInit[PROP_NAME_COUNTRY].countries
                                    .map(c =>
                                        (<option value={c.code}
                                                 dangerouslySetInnerHTML={{__html: c.description}}></option>)
                                    )
                            }
                        </select>
                    </div>
                }
                {
                    displayCompanyInfo &&
                    <div className="grid__col-sm-6">
                        <label htmlFor={PROP_NAME_COMPANY_TYPE}>Company Type</label>
                        <select id={PROP_NAME_COMPANY_TYPE}
                                className={"select-input--large " + hasInputClassCompanyType}
                                value={data[PROP_NAME_COMPANY_TYPE]}
                                onChange={this.companyTypeChange}
                        >
                            <option value={""}>Select...</option>
                            {
                                userDataInit[PROP_NAME_COMPANY_TYPE].companyTypes
                                    .map(c =>
                                        (<option value={c} dangerouslySetInnerHTML={{__html: c}}></option>)
                                    )
                            }
                        </select>
                    </div>
                }
                {
                    displayCompanyInfo &&
                    <div className="grid__col-sm-6">
                        <label htmlFor={PROP_NAME_COMPANY_NAME}>Company Name</label>
                        <input id={PROP_NAME_COMPANY_NAME}
                               className={"text-input text-input--large responsive " + hasInputClassCompanyName}
                               value={data[PROP_NAME_COMPANY_NAME]}
                               onChange={this.companyNameChange}
                        />
                        {
                            hasMessage(metadata, PROP_NAME_COMPANY_NAME) &&
                            <div className="error"
                                 style={{display: 'block'}}>{metadata[PROP_NAME_COMPANY_NAME].message}</div>
                        }
                    </div>
                }
            </div>
        );
    }
}

AboutYouInputComponent.propTypes = {
    // This is the object that contains properties like country, address, etc
    data: PropTypes.object.isRequired,

    metadata: PropTypes.object.isRequired,

    // This is the function to set properties of the "data" object. The function should take property name as first parameter and the value as the second parameter.
    setFormState: PropTypes.func.isRequired,
    userDataInit: PropTypes.object.isRequired,
    hideCountry: PropTypes.bool,
    onExtractData: PropTypes.func
};

export default AboutYouInputComponent;

